const size = {
	lg: window.matchMedia('(max-width: 1440px)').matches,
	md: window.matchMedia('(max-width: 1024px)').matches,
}

export { size }
